// Libraries
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { secToHourMin } from "../../../helpers/secToMinS";
import { useTranslations } from "next-intl";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function ProgressionCard({ course, progression, ...props }) {
    const t = useTranslations();

    if (!course) return null;

    if (
        course &&
        course.programConstructorVersion &&
        course.programConstructorVersion >= 2
    ) {
        // For program with constructor structure version >= 2
        let link = "dashboard";

        return (
            <Link href={`/accelerators/${course.slug}/${link}`}>
                <Card className="hover:bg-gray-50 dark:bg-bgDark-840 dark:hover:border-primary dark:hover:bg-bgDark-840/70 dark:border-borderDark transition-all duration-100 h-full flex flex-col overflow-hidden">
                    <CardHeader className="pb-3 flex-1">
                        <div className="flex justify-between items-start">
                            <Image
                                src={course.image}
                                alt={course.name}
                                width={64}
                                height={64}
                            />
                            <div className="flex gap-2 flex-wrap">
                                {/* {course.isPopular && (
                                <Badge>{t("course_popular")}</Badge>
                            )}
                            {course.isSoon && <Badge>{t("course_soon")}</Badge>}
                            {course.isNew && (
                                <Badge variant="confidence">
                                    {t("course_new")}
                                </Badge>
                            )}
                            {course.lang !== locale && (
                                <Badge variant="outline">
                                    {t("course_not_same_lang_short")}
                                </Badge>
                            )} */}
                            </div>
                        </div>
                        <CardTitle className="pt-4 leading-relaxed">
                            <h2>{course.name}</h2>
                        </CardTitle>
                        <CardDescription className="line-clamp-4">
                            {course.summary}
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="px-3">
                        <div className="flex justify-end items-center gap-1">
                            <Badge variant="secondary">
                                {progression.secondsConsumed > 120
                                    ? t("ProgressionCard_minutesPassed", {
                                          time: secToHourMin(
                                              progression.secondsConsumed,
                                          ),
                                      })
                                    : t("ProgressionCard_minutePassed", {
                                          time: secToHourMin(
                                              progression.secondsConsumed,
                                          ),
                                      })}
                            </Badge>
                            <span className="text-sm text-muted-foreground">
                                •
                            </span>
                            <Badge variant="secondary">
                                {progression.total} %
                            </Badge>
                        </div>
                    </CardContent>
                    <div className="bg-primary/10 h-1">
                        <div
                            className="bg-primary h-full"
                            style={{ width: `${progression.total}%` }}
                        ></div>
                    </div>
                </Card>
            </Link>
        );
    } else {
        let link = "";
        if (course.category == "program") {
            if (course.slug == "le-programme-rocket-2020") {
                if (progression && progression.part) {
                    link = `${progression.part}/${progression.position}`;
                } else {
                    link = "1/1";
                }
            } else {
                link = "dashboard";
            }
        } else {
            if (progression && progression.part) {
                link = `${progression.part}/${progression.position}`;
            } else {
                link = "1/1";
            }
        }

        return (
            <Link href={`/course/${course.slug}/${link}`}>
                <Card className="hover:bg-gray-50 dark:bg-bgDark-840 dark:hover:border-primary dark:hover:bg-bgDark-840/70 dark:border-borderDark transition-all duration-100 h-full flex flex-col overflow-hidden">
                    <CardHeader className="pb-3 flex-1">
                        <div className="flex justify-between items-start">
                            <Image
                                src={course.image}
                                alt={course.name}
                                width={64}
                                height={64}
                            />
                            <div className="flex gap-2 flex-wrap">
                                {/* {course.isPopular && (
                                <Badge>{t("course_popular")}</Badge>
                            )}
                            {course.isSoon && <Badge>{t("course_soon")}</Badge>}
                            {course.isNew && (
                                <Badge variant="confidence">
                                    {t("course_new")}
                                </Badge>
                            )}
                            {course.lang !== locale && (
                                <Badge variant="outline">
                                    {t("course_not_same_lang_short")}
                                </Badge>
                            )} */}
                            </div>
                        </div>
                        <CardTitle className="pt-4 leading-relaxed">
                            <h2>{course.name}</h2>
                        </CardTitle>
                        <CardDescription className="line-clamp-4">
                            {course.summary}
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="px-3">
                        <div className="flex justify-end items-center gap-1">
                            <Badge variant="secondary">
                                {progression.secondsConsumed > 120
                                    ? t("ProgressionCard_minutesPassed", {
                                          time: secToHourMin(
                                              progression.secondsConsumed,
                                          ),
                                      })
                                    : t("ProgressionCard_minutePassed", {
                                          time: secToHourMin(
                                              progression.secondsConsumed,
                                          ),
                                      })}
                            </Badge>
                            <span className="text-sm text-muted-foreground">
                                •
                            </span>
                            <Badge variant="secondary">
                                {progression.total} %
                            </Badge>
                        </div>
                    </CardContent>
                    <div className="bg-primary/10 h-1">
                        <div
                            className="bg-primary h-full"
                            style={{ width: `${progression.total}%` }}
                        ></div>
                    </div>
                </Card>
            </Link>
        );
    }
}
